module.exports = {
    
    request: function (req, token) {
        if (req.url == process.env.API_URL + '/auth/login') {
            req.body = {token};
        };
        this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token});
    },
    
    response: function (res) {
        var headers = this.options.http._getHeaders.call(this, res);
        var token = res.body.token || false;

        if (token) {
            return token.trim();
        }
    }
};


// WEBPACK FOOTER //
// ./src/auth.js